module.exports = __webpack_public_path__ + "r-v3/img/text_blue.09db1326.svg";